"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInlineResponse2002 = void 0;
const inline_response2002_message_1 = require("./inline-response2002-message");
function parseInlineResponse2002(data) {
    if (data.message !== null && typeof data.message === 'object')
        data.message = (0, inline_response2002_message_1.parseInlineResponse2002Message)(data.message);
    return data;
}
exports.parseInlineResponse2002 = parseInlineResponse2002;
